import {getVersion, getVersionName} from '@aboutyou/config';
import {getFeatureFlagVersion} from '@aboutyou/feature-flags';
import type {Response} from 'express';

export const getVersionWithFeatureFlagVersion = () =>
  `${getVersionName()}-${getVersion()}-${getFeatureFlagVersion()}`;

export const getVersionNameForDDTraces = () =>
  `${getVersionName()}-${getFeatureFlagVersion()}`;

export const setAppVersionHeader = (response: Response) => {
  response.setHeader('X-App-Version', getVersionWithFeatureFlagVersion());
};
